<template lang="pug">
  tfoot
    tr(:class="b()")
      th(colspan="4") Total
      th {{ totals.interest | formatCurrency(currency) }}
      th {{ totals.insurances | formatCurrency(currency) }}
      th {{ totals.defaultsAndPenalties | formatCurrency(currency) }}
      th(colspan="2")
      th {{ totals.totalAmortization | formatCurrency(currency) }}
      th(colspan="2")
</template>

<script>
export default {
  name: 'borrower-statement-table-footer',

  props: {
    totals: { type: Object, required: true },
    currency: { type: Object, required: true },
  },
};
</script>

<style lang="sass" scoped>
  .borrower-statement-table-footer
    th
      padding: 8px 9px
      text-align: right

      &:first-child
        text-align: center
        background-color: darken(white, 10%)
</style>
